import React from 'react';
import AdminDashboardLayout from '../Common/AdminDashboardLayout/AdminDashboardLayout';
import SpaceManagementLayout from './SpaceManagementLayout';
import ManageVisits from './ManageVisits';

const ManageVisitsWrapper = () => {
  return (
    <AdminDashboardLayout>
      <SpaceManagementLayout activeTab="2">
        <ManageVisits />
      </SpaceManagementLayout>
    </AdminDashboardLayout>
  );
};

export default ManageVisitsWrapper;
